import type { FC, ReactNode } from "react";
import { useAttachmentEditor } from "./useAttachmentEditor.js";

export const AttachmentEditorContainer: FC<{
  knowledgeBaseId: string;
  attachmentId: string;
  pendingPatch: { find: string; replace: string } | null;
  onPatchApplied: () => void;
  onClose: () => void;
  sidebar: ReactNode;
}> = ({ sidebar, ...editorProps }) => {
  const editor = useAttachmentEditor(editorProps);
  return (
    <>
      {editor.toolbar}
      <div className="flex min-h-0 flex-1">
        {editor.content}
        {sidebar}
      </div>
    </>
  );
};
